import React from 'react';
import { List } from '@material-ui/core';
import NavMenuItem from './NavMenuItem';
import NavCollapse from './NavCollapse';
import NavMega from './NavMega';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

import { useLocation } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  horizontalNavMenu: {
    position: 'relative',
    display: 'flex',
    marginLeft: 80,
    marginRight: -14,
  },
    horizontalNavMenu2: {
    position: 'relative',
    display: 'flex',
    marginLeft: 115,
    marginRight: -14,
  },
}));

const checkLayout = (location) => {
  if(location.pathname==="/dashboard" || location.pathname==="/fichas_tecnicas"){
    return true
  } else{
    return false
  }
}

const CmtHorizontal = props => {
  const { menuItems } = props;
  const classes = useStyles();
  const location = useLocation();
  return (
    <List component="nav" disablePadding className={checkLayout(location) ? clsx(classes.horizontalNavMenu2, 'Cmt-horizontalNavMenu') : clsx(classes.horizontalNavMenu, 'Cmt-horizontalNavMenu')}>
      {menuItems.map((item, index) => {
        switch (item.type) {
          case 'collapse':
            return <NavCollapse {...item} key={index} />;
          case 'mega':
            return <NavMega {...item} key={index} />;
          case 'item':
            return <NavMenuItem {...item} key={index} />;
          default:
            return null;
        }
      })}
    </List>
  );
};

export default CmtHorizontal;
